<template>
	<div class="app-container gameDetail">
		<el-card class="mb10">
			<div class="maininfo">
				<div class="cover">
					<el-image class="img" :src="info.gameImg" fit="cover">
						<div slot="error" class="image-slot">
							<i class="el-icon-picture-outline"></i>
						</div>
					</el-image>
				</div>
				<div class="flx1 fz13">
					<div class="title">赛事标题：{{info.gameName}}</div>
					<!-- <div class="user alnCt">
						<el-image class="avatar" :src="info.avatarUrl">
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							</div>
						</el-image>
						<div class="name">{{info.userName}}</div>
					</div> -->

					<!-- <div class="status">
						审核状态：<span class="statusTag warn" v-if="info.isCheck == '1'"> 待审核 </span><span
							class="statusTag danger" v-if="info.isCheck == '2'"> 审核拒绝  丨  原因：{{info.checkRemark}}</span><span
							class="statusTag success" v-if="info.isCheck == '3'"> 审核通过 </span>
					</div> -->
					<!-- <div class="status">
						赛事进度：<span class="statusTag gray" v-if="info.state == '1'"> 已结束 </span>
						<span class="statusTag success" v-if="info.state == '2'"> 进行中 </span>
						<span class="statusTag primary" v-if="info.state == '3'"> 报名中 </span>
						<span class="primary" v-if="info.isCheck != '3' || (info.isCheck == '3' && !info.state)"> - </span>
					</div> -->
				</div>
				<div class="flxR">
					<!-- <el-button class="action" size="small" icon="el-icon-check" plain type="primary"
						@click="handleAudit()" v-if="info.isCheck == '1'">审批赛事</el-button> -->
					<el-button class="action" size="small" icon="el-icon-delete-solid" plain type="danger"
						@click="handleDel()" v-if="info.isCheck == '1' || info.isCheck == '2'">删除赛事</el-button>
					<el-button class="action" size="small" icon="el-icon-check" plain type="primary"
						@click="handleAudit()">赛事总结</el-button>
				</div>
			</div>
		</el-card>
		<!-- v-if="info.memberId" -->
		<el-card class="tabBox">
			<el-tabs v-model="activeName">
				<el-tab-pane label="赛事详情" name="detail">
					<infoTab :id="id" :name="activeName"></infoTab>
				</el-tab-pane>
				<el-tab-pane label="成员列表" name="list">
					<listTab :id="id" :name="activeName"></listTab>
				</el-tab-pane>
				<el-tab-pane label="赛事总结" name="list2">
					<listTab :id="id" :name="activeName"></listTab>
				</el-tab-pane>
			</el-tabs>
		</el-card>

		<el-dialog title="审核赛事" :visible.sync="dialogShow" width="600px" append-to-body>
			<el-form ref="setform" :model="setParams" size="mini">
				<el-form-item label="" prop="isCheck">
					<el-radio-group v-model="setParams.isCheck">
						<el-radio label="3">审核通过</el-radio>
						<el-radio label="2">审核拒绝</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="" prop="checkRemark" v-if="setParams.isCheck == '2'">
					<el-input :rows="5" type="textarea" maxlength="20" placeholder="填写拒绝原因" show-word-limit
						v-model="setParams.checkRemark" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="dialogShow = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import * as API_Game from "@/api/sportManage/game";

	import infoTab from './tabs/info.vue'
	import listTab from './tabs/member.vue'

	export default {
		name: "gameDetail",
		components: {
			infoTab,
			listTab
		},
		data() {
			return {
				activeName: '',
				info: {
					// memberId: 7
					avatarUrl:'',
					gameImg:''
				},

				setParams: {
					isCheck: 3,
					id: this.$route.query.id
				},
				dialogShow: false
			};
		},
		created() {
			this.id = this.$route.query.id;
			this._getDetail()
		},
		methods: {
			// 接口-赛事详情
			_getDetail() {
				API_Game.gameInfo({
					id: this.id
				}).then((res) => {
					console.log(res.data);
					this.info = res.data
					this.activeName = 'detail';
				})
			},
			// 接口-删除赛事
			_delGame(id) {
				API_Game.gameDel(id).then((res) => {
					console.log(res.data);
					this.$message({
						message: "已删除",
					});
					setTimeout(() => {
						this.$router.back()
					}, 1500);
				}).catch((err) => {

				});
			},
			// 接口-审核赛事
			_auditGame() {
				API_Game.gameAudit([this.setParams]).then((res) => {
					this.$message({
						message: "操作成功",
						type: "success",
					});
					this.dialogShow = false
					this._getDetail()
				}).catch((err) => {

				});
			},
			handleAudit() {
				this.dialogShow = true
				this.setParams.isCheck = '3'
			},
			handleDel() {
				this.$confirm(`确定删除该赛事？`, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this._delGame(this.id)
					})
					.catch(() => {});
			},
			submitForm() {
				if (this.setParams.isCheck == '2' && !this.setParams.checkRemark) {
					this.$message({
						message: "请填写拒绝原因",
						type: "error",
					});
					return
				}
				this._auditGame()
			},

		},
	};
</script>

<style scoped lang="scss">
	.gameDetail {
		.maininfo {
			display: flex;
			align-items: center;
			height: 240px;
			padding: 0 10px;

			.cover {
				width: 360px;
				height: 200px;
				border-radius: 5px;
				overflow: hidden;
				margin-right: 30px;

				.img {
					width: 100%;
					height: 100%;
				}
			}

			.title {
				margin-bottom: 10px;
				font-size: 16px;
			}

			.status {
				margin-top: 16px;
				color: #fff;
			}

			.statusTag {
				color: #fff;
			}

			.flxR {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				height: 100%;
				padding: 20px 0;
			}

			.action {
				width: 100px;
				height: 36px;
				margin: 0 0 10px 0;
			}
		}

		.tabBox {}
	}
</style>
<style lang="scss">
	@import "../../../assets/styles/common.scss";

	.gameDetail {
		.maininfo {
			.el-card__body {
				display: flex;
				align-items: center;
				width: 100%;
				height: 120px;
			}
		}
 
		.avatar {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			margin-right: 10px;
			background-color: #eee;
		}
	}
</style>